import {post} from '../interceptor'

let preUrl = '';
export default {
  getTradeType(params) { return post(preUrl, '/carbonManage/getTradeType', params) },
  getAllProvince(params) { return post(preUrl, '/carbonManage/getAllProvince', params) },
  getCarbonModel(params) { return post(preUrl, '/carbonManage/getCarbonModel', params) },
  genCarbonReport(param1, param2) { return post(preUrl, '/carbonManage/genCarbonReport?tradeId=' + param1, param2) }
}



// WEBPACK FOOTER //
// ./src/api/energy/carbonManage.js